export default __webpack_public_path__ + "static/Plots0104-43237529dfdd039f434c883944ade625.jpg";